import { Component } from '@angular/core';
import { DatePipe } from '@angular/common';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { TamperEvent } from '@app/models/tamper-event.interface';
import { TamperEventHelperService } from '@app/services/helpers/tamper-event-helper.service';
import { Observable } from 'rxjs';
import { HeadMetaComponent } from "@app/components/head-meta/head-meta.component";
import { LoadingErrorBlockComponent } from "@app/components/loading-error-block/loading-error-block.component";
import { LetDirective } from '@ngrx/component';
import { CreatedUpdatedDisplayComponent } from "@app/components/created-updated-display/created-updated-display.component";
import { DetailDisplayComponent } from "@app/components/detail-display/detail-display.component";
import { faCheck, faPenToSquare, faXmark, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { AuthService } from '@app/services/auth.service';

@Component({
    selector: 'app-tamper-event-detail',
    templateUrl: './detail.page.html',
    styleUrl: './detail.page.scss',
    imports: [
        HeadMetaComponent,
        LoadingErrorBlockComponent,
        LetDirective,
        CreatedUpdatedDisplayComponent,
        DetailDisplayComponent,
        FontAwesomeModule,
        RouterModule,
        DatePipe,
    ]
})
export class TamperEventDetailPage {
  title = "Tamper Event Detail";
  id: number;
  tamperEvent$: Observable<TamperEvent>;

  faCheck = faCheck;
  faXmark = faXmark;
  faPenToSquare = faPenToSquare;
  faArrowLeft = faArrowLeft;

  constructor(
    private route: ActivatedRoute,
    private tamperEventHelper: TamperEventHelperService,
    public auth: AuthService,
  ) {
    this.id = this.route.snapshot.params['id'];
    this.tamperEvent$ = this.tamperEventHelper.getById(this.id);
  }
}
